import { toast } from 'react-toastify';

import { isArray } from 'lodash';

import { t } from '~/helpers';

export function getToastErrors(errors) {
  if (isArray(errors)) errors.map((error) => toast.error(t(error)));
  else toast.error(t(errors));
}
